/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AddCRMMatchBypassRequest = {
  type: 'CRMMatchBypass',
} as const;
